import JournalTable from "../../components/JournalTable/JournalTable.js";
import styles from "./Journals.module.css";

const Journals = () => {
  return (
    <main className={styles["journals-page"]}>
      <h1>Journal Metrics</h1>
      <p>
        These statistics are calculated from user-submitted manuscript data.
        Accordingly, we acknowledge they are only estimates. &quot;Sample
        Size&quot; reports the number of manuscripts used to calculate a
        journal&apos;s metrics. Journal metrics involving revisions are computed
        using both major and minor revisions.
      </p>
      <JournalTable />
    </main>
  );
};

export default Journals;
